import React from 'react'

import './labeled-price.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    label?: React.ReactNode
    children?: React.ReactNode
    strong?: boolean
  }
>

const LabeledPrice = ({className, label, children, strong = false, ...props}: Props) => (
  <div {...props} className={cn('LabeledPrice', {strong}, className)}>
    <div className="LabeledPrice__label">{label}</div>
    <div className="LabeledPrice__price">{children}</div>
  </div>
)

export default LabeledPrice
